import { FeatureFlag } from '@domain'

import api from '.'

// Query Key factory
export const FeatureFlagsKey = {
	all: ['feature-flags'],
}

const FeatureFlagsApi = {
	getAll: () => api.get<APIRes<FeatureFlag[]>>('/feature-flags').then((res) => res.data.data),
	update: ({ id, value }: { id: Id; value: boolean }) =>
		api.patch<APIRes<FeatureFlag[]>>(`/feature-flags/${id}`, { flagStatus: value }),
}

export default FeatureFlagsApi
